import request from '~/utils/http';


export function getOrderNumber() {
  return request({
    url: 'api/AgentOrder/GetOverview',
    method: 'post'
  })
}

export function getRate() {
  return request({
    url: 'api/FrontDashboard/GetCurrentRate',
    method: 'post',
    data: {}
  })
}

export function getCustomsRate() {
  return request({
    url: 'api/FrontDashboard/GetMonthExchangeRateAsync',
    method: 'post'

  })
}

export function getMesSenc() {
  return request({
    url: 'api/MesSendConfig/GetLastContent',
    method: 'post',
    data: {}
  })
 }

 export function GetSwitchClientList() {
  return request({
    url: '/api/User/GetSwitchClientList',
    method: 'post',
    data: {}
  })
 } 

 export function SwitchClient(sendData) {
  return request({
    url: '/api/User/SwitchClient',
    method: 'post',
    data: sendData
  })
 } 


